package example.shadcn_kotlin.ui.pages.docs.components.aspect_ratio

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.AspectRatioDemo

@Page
@Composable
fun IndexPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/aspect-ratio/index.md", mapOf("title" to listOf("Aspect Ratio"), "description" to listOf("Displays content within a desired ratio."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/aspect-ratio"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/aspect-ratio#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import react.dom.html.ReactHTML.img
import shadcn.ui.components.AspectRatio
import web.cssom.ClassName

val AspectRatioDemo = FC<Props> {
    AspectRatio {
        ratio = 16 / 9
        img {
            src = "https://images.unsplash.com/photo-1588345921523-c2dcdb7f1dcd?w=800&dpr=2&q=80"
            alt = "Photo by Drew Beamer"
            className = ClassName("rounded-md object-cover")
        }
    }
}"""){ 
 AspectRatioDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import react.dom.html.ReactHTML.img
import shadcn.ui.components.AspectRatio
""", lang= "kotlin", highlight= "")
            CodeBlock("""AspectRatio {
    ratio = 16 / 9
    className = ClassName("bg-muted")
    img {
        src = "https://images.unsplash.com/photo-1588345921523-c2dcdb7f1dcd?w=800&dpr=2&q=80"
        alt = "Photo by Drew Beamer"
        className = ClassName("rounded-md object-cover")
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
